import {useContext} from "react";
import {MyContext} from "../context/myContext";

const AddUserBox = ({formComponent: FormComponent}) => {
    const {handleShowForm, formTitle, showForm, showEditForm} = useContext(MyContext)
    return(
        <div className={`${(showForm || showEditForm) && 'show-add-user-box'} add-user-box`}>
            <div className='popup-title'>
                <i className="fa fa-times close-icon" onClick={handleShowForm}></i>
                <p>{formTitle}</p>
            </div>
            <FormComponent />
        </div>
    )
}

export default AddUserBox